import { render, staticRenderFns } from "./imprVendor.vue?vue&type=template&id=5c788ee8"
import script from "./imprVendor.vue?vue&type=script&lang=js"
export * from "./imprVendor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c788ee8')) {
      api.createRecord('5c788ee8', component.options)
    } else {
      api.reload('5c788ee8', component.options)
    }
    module.hot.accept("./imprVendor.vue?vue&type=template&id=5c788ee8", function () {
      api.rerender('5c788ee8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/ibm/imprVendor.vue"
export default component.exports